<template>
  <div>
    <div v-if="asyncState != 'pending' && recipes == null">
      <h1 class="title">Ci dispiace, ma non ci sono ricette disponibili :(</h1>
      <p class="">
        Contattaci e creeremo una ricetta speciale per
        <span v-if="isMoreThanADog"
          >i tuoi {{ wizardData.numberOfDogs }} amici a quattro zampe</span
        >
        <span v-else
          >{{ sex == 2 ? "la tua" : "il tuo" }} {{ dogData.name | capitalize }}</span
        >
      </p>
    </div>
    <div v-else>
      <h1 class="title">
        Qual è il
        <span v-if="isMoreThanADog">loro</span>
        <span v-else>suo</span>
        gusto preferito?
      </h1>

      <div class="max-w-xl w-full mx-auto">
        Controlla gli ingredienti della ricetta che stai acquistando per verificare che
        <span v-if="isMoreThanADog"> i tuoi cani </span>
        <span v-else> il tuo cane </span>
        non ne
        <span v-if="isMoreThanADog"> siano </span>
        <span v-else> sia </span>
        allergico
      </div>

      <form class="form max-w-2xl mx-auto" @submit.prevent>
        <div class="form-group">
          <div class="loading-wrapper" v-if="asyncState == 'pending'">
            <div class="loader bg-[#f6f4f0] w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: #f6f4f0;
                  display: block;
                  shape-rendering: auto;
                "
                width="200px"
                height="200px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle cx="50" cy="23" r="13" fill="#e82716">
                  <animate
                    attributeName="cy"
                    dur="1s"
                    repeatCount="indefinite"
                    calcMode="spline"
                    keySplines="0.45 0 0.9 0.55;0 0.45 0.55 0.9"
                    keyTimes="0;0.5;1"
                    values="23;77;23"
                  ></animate>
                </circle>
              </svg>
            </div>
          </div>

          <div
            id="recipe-slider"
            class="swiper max-w-[600px] mx-auto relative"
            v-show="asyncState !== 'pending'"
          >
            <swiper
              ref="rbslider"
              class="swiper max-w-[600px] mx-auto"
              :options="swiperOption"
            >
              <swiper-slide v-for="recipe in recipes" class="py-4 px-2" :key="recipe.id">
                <label
                  class="form-check-label rounded-2xl flex flex-col shadow-lg border-3 border-solid pb-5 overflow-hidden cursor-pointer transition-colors"
                  :class="[
                    dog.recipeId == recipe.id
                      ? 'border-red-600 bg-red-50 '
                      : 'border-transparent bg-gray-50 ',
                  ]"
                >
                  <input
                    v-model.number="$v.dog.recipeId.$model"
                    class="form-check-input hidden"
                    type="radio"
                    :value="recipe.id"
                  />
                  <div class="recipe-thumb aspetct-video overflow-hidden h-32">
                    <img
                      :src="recipe.postThumbnailUrl"
                      class="w-full h-auto object-cover object-center"
                    />
                  </div>
                  <!-- <img :src="iconUrl(recipe.icon)" class="size-full" /> -->
                  <div
                    class="relative aspect-square bg-white mx-auto h-14 w-14 overflow-hidden rounded-full -top-7 -mb-7"
                  >
                    <img
                      :src="recipe.recipeMainIngredientIcon"
                      class="mx-auto w-24 h-16 object-fill object-center"
                    />
                  </div>

                  <h4 class="rb_recipe-title">Bowl di {{ recipe.name }}</h4>
                  <div class="rb_recipe-description text-xs font-normal text-center">
                    {{ recipe.postExcerpt }}
                  </div>

                  <a
                    class="underline block text-sm text-center font-normal"
                    v-on:click.stop="showMore(recipe.id)"
                    >Scopri gli ingredienti Principali</a
                  >
                  <p class="mt-2 text-center text-base" href="#">
                    <span class="font-semibold text-lg"
                      >{{ recipe.fourWeeks["totalPricePerDay"] }}&euro;</span
                    >
                    al giorno
                  </p>

                  <div
                    class="p-1.5 w-2/3 text-base font-medium border border-solid text-center mx-auto border-red-600 rounded-lg mt-4 transition-colors"
                    :class="[
                      dog.recipeId == recipe.id
                        ? 'bg-red-600 text-red-50 '
                        : 'bg-red-50 text-red-600 ',
                    ]"
                  >
                    Seleziona<span
                      :class="[dog.recipeId == recipe.id ? 'inline-block' : 'hidden']"
                      >ta</span
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                      :class="[dog.recipeId == recipe.id ? 'inline-block' : 'hidden']"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                  </div>
                </label>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination" slot="pagination">&nbsp;</div>
            <div class="swiper-button-prev" slot="button-prev">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div class="swiper-button-next" slot="button-next">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <div v-if="$v.dog.recipeId.$error" class="error">campo obbligatorio</div>
        </div>

        <transition
          enter-class="opacity-0 scale-75"
          enter-to-class="opacity-100 scale-100"
          enter-active-class="transition-all duration-300 ease-out"
          leave-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-75"
          leave-active-class="transition-all duration-300 ease-in"
        >
          <div
            v-show="showModal"
            class="fixed inset-0 flex items-center justify-center z-10"
          >
            <div
              v-on:click="closeModal()"
              class="absolute inset-0 bg-white bg-opacity-60"
            >
              &nbsp;
            </div>
            <div
              class="relative bg-gray-50 rounded-2xl p-0 md:max-w-sm max-w-xs w-full shadow-lg text-left overflow-hidden"
            >
              <a
                class="absolute bg-transparent top-2 left-2 rounded-full flex items-center justify-center p-1 cursor-pointer"
                v-on:click="closeModal()"
              >
                <svg
                  class="w-6 h-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </a>
              <img
                :src="modalRecipe.recipeAnimation"
                class="w-full h-48 object-cover object-center block"
              />
              <div class="px-4 pt-6">
                <h3 class="p-0">Ingredienti</h3>
                <div class="text-sm md:text-base pt-2">
                  {{ modalRecipe.ingredientExcerpt }}
                </div>
              </div>
              <div class="p-4 text-sm md:text-base">
                <h3 class="p-0">Tabella Nutrizionale</h3>
                <div class="bg-gray-100 px-2 py-2">
                  <strong>Proteine:</strong>
                  {{ modalRecipe.nutritionProteins }}%
                </div>
                <div class="px-2 py-1">
                  <strong>Grassi:</strong> {{ modalRecipe.nutritionFats }}%
                </div>
                <div class="bg-gray-100 px-2 py-1">
                  <strong>Fibre:</strong> {{ modalRecipe.nutritionFibers }}%
                </div>
                <div class="px-2 py-1">
                  <strong>Umidità:</strong>
                  {{ modalRecipe.nutritionHumidity }}%
                </div>
                <div class="bg-gray-100 px-2 py-1">
                  <strong>Ceneri:</strong> {{ modalRecipe.nutritionHashes }}%
                </div>
              </div>
            </div>
          </div>
        </transition>
      </form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      asyncState: null,
      swiperOption: {
        centeredSlides: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        breakpoints: {
          // when window width is >= 640px
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "hidden",
        },
      },
      showModal: "",
      modalRecipe: {},
      recipes: [],
      dogDetails: [],
      dog: {
        recipeId: null,
      },
    };
  },
  validations: {
    dog: {
      recipeId: {
        required,
      },
    },
  },
  watch: {},
  computed: {
    isMoreThanADog() {
      return this.wizardData.numberOfDogs > 1 && this.wizardData.sameDiet;
    },
  },
  methods: {
    showMore(id) {
      this.showModal = id;
      this.modalRecipe = this.recipes.filter((recipe) => recipe.id == id)[0];
    },
    closeModal() {
      this.showModal = "";
      this.modalRecipe = {};
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            dog: {
              recipeId: this.dog.recipeId,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    async getRecipes() {
      this.asyncState = "pending";
      var updatedData = [];
      let dog = [];
      updatedData = Object.assign({}, this.wizardData);

      // get recipe prices to only one dog if different diet
      // otherwise get prices to all
      if (this.wizardData.numberOfDogs >= 2 && !this.wizardData.sameDiet) {
        updatedData.numberOfDogs = 1;
        updatedData.dogs = [];
        dog = Object.assign(this.dogData, this.dog);
        Object.assign(dog, this.initialDog);
        updatedData.dogs.push(dog);
      } else if (this.wizardData.numberOfDogs >= 2 && this.wizardData.sameDiet) {
        // first needs to update all dogs with isFullMeal:
        for (let i = 0; i < this.wizardData.numberOfDogs; i++) {
          Object.assign(updatedData.dogs[i], this.dog);
          Object.assign(updatedData.dogs[i], this.initialDog);
        }
      } else {
        Object.assign(updatedData.dogs[updatedData.indexDog], this.dog);
        Object.assign(updatedData.dogs[updatedData.indexDog], this.initialDog);
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          snakecaseKeys({ form: updatedData, selectedRecipeId: null })
        ),
      };

      const url = this.$restAPIurlRB + "recipe-prices";
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      var camelcaseData = camelcaseKeys(data, { deep: true });
      this.recipes = camelcaseData.recipes;
      if (this.recipes) {
        this.dogDetails = camelcaseData.dogDetails.dogs;
      } else {
        this.$emit("disableActionButton", true);
      }
      this.asyncState = "success";
      this.$refs.rbslider.$el.focus();
    },
  },
  activated() {
    this.dog.recipeId = this.dogData.recipeId;
    this.$v.$reset();
    this.getRecipes();
  },
  mounted() {
    this.getRecipes();
  },
};
</script>

<style>
.swiper-container {
  /*  padding: 0 2rem !important; */
}

#recipe-slider .swiper-button-next,
#recipe-slider .swiper-button-prev {
  opacity: 0;
  color: #e82716;
  transition: opacity 0.2s ease-in-out;
}

#recipe-slider .swiper-button-next:after,
#recipe-slider .swiper-button-prev:after {
  /* -webkit-text-stroke: 10px red; */
  display: none;
}

#recipe-slider .swiper-button-next {
  right: -2rem;
}

#recipe-slider .swiper-button-prev {
  left: -2rem;
}

#recipe-slider:hover .swiper-button-next,
#recipe-slider:hover .swiper-button-prev {
  opacity: 0.5;
}

#recipe-slider .swiper-button-next:hover,
#recipe-slider .swiper-button-prev:hover {
  opacity: 1;
}

#recipe-slider .swiper-pagination {
  @apply w-full;
}

#recipe-slider .swiper-pagination-bullet {
  @apply rounded bg-white opacity-70 w-10 md:w-16 h-2 transition-colors;
}

#recipe-slider .swiper-pagination-bullet + .swiper-pagination-bullet {
  @apply ml-3;
}

#recipe-slider .swiper-pagination-bullet-active {
  @apply bg-red-600 opacity-100;
}
</style>
